import React, { useEffect, useCallback } from 'react';
import { Grid, FormControlLabel } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import SwitchAction from '../../actions/SwitchAction';
import CalibratingModal from './CalibratingModal';
import AudioService from '../../../../services/studio/AudioService';
import { Button } from '../../..';
import { StudioControlStyles } from '../../styles';
import {
  setAutoScrollAudioService,
  setSupportUserMedia,
  setMediaNotAvailable,
} from '../../../../store/modules/studio/actions';
import {
  selectIsConnectingAudioService,
  selectIsCalibratingAudioService,
  selectAutoScrollAudioService,
  selectIsSupportUserMedia,
  selectIsPlayPrompter,
  selectIsCountdown,
  selectIsSupportUserAudio,
  selectIsOpen,
  selectMediaNotAvailableStatus,
} from '../../../../store/modules/studio/selectors';
import WaveIcon from '../../../../assets/icons/WaveIcon.svg';
import StudioToolTip from '../../actions/StudioToolTip';
import { notify } from '../../../../store/modules/notifications/actions';
import StudioNotification from '../../StudioNotification';

const AudioServiceAction = () => {
  const classes = StudioControlStyles();

  const dispatch = useDispatch();

  const isOpen = useSelector(selectIsOpen);
  const autoScrollAudioService = useSelector(selectAutoScrollAudioService);
  const isConnectingAudioService = useSelector(selectIsConnectingAudioService);
  const isCalibrating = useSelector(selectIsCalibratingAudioService);
  const isSupportUserMedia = useSelector(selectIsSupportUserMedia);
  const isSupportUserAudio = useSelector(selectIsSupportUserAudio);
  const isPlay = useSelector(selectIsPlayPrompter);
  const isCountdown = useSelector(selectIsCountdown);
  const isDisabledVoiceScroll = (!isSupportUserAudio || (isCountdown || isPlay));
  const mediaIsNotAvailableStatus = useSelector(selectMediaNotAvailableStatus);

  useEffect(() => {
    if (isOpen) {
      const supportUserMedia = AudioService.isSupportUserMedia();
      dispatch(setSupportUserMedia(supportUserMedia));

      if (!supportUserMedia) {
        dispatch(setAutoScrollAudioService(false));
      }
      if (!supportUserMedia && !mediaIsNotAvailableStatus) {
        dispatch(notify({
          type: 'custom',
          message: (<StudioNotification message="Media devices is not supported" />),
        }));
        dispatch(setMediaNotAvailable(true));
      }

      if (supportUserMedia && mediaIsNotAvailableStatus) {
        dispatch(setMediaNotAvailable(false));
      }
    }
  }, [isOpen, isSupportUserAudio, isSupportUserMedia, dispatch, mediaIsNotAvailableStatus]);


  const onAutoScrollAudioServiceHandler = useCallback(() => {
    dispatch(setAutoScrollAudioService(!autoScrollAudioService));
  }, [dispatch, autoScrollAudioService]);


  const calibrateHandler = useCallback(() => {
    if (window.studioAudioService !== undefined) {
      window.studioAudioService.calibrate();
    }
  }, []);
  const voiceScrollTooltipTitle = 'Voice Scroll will scroll the teleprompter only when you are talking. '
               + 'If Voice Scroll is disabled then audio is not available. '
               + ' It is known that the IOS Chrome browser is not supported';

  return (
    <Grid item container style={{ paddingTop: 0 }}>
      <StudioToolTip title={voiceScrollTooltipTitle}>
        <Grid item>
          <FormControlLabel
            label="Voice Scroll"
            labelPlacement="end"
            htmlFor="audio-service-switch"
            classes={{
              root: classes.labelRoot,
              label: isDisabledVoiceScroll ? classes.disabledSwitchLabel : classes.labelControl,
            }}
            control={(
              <SwitchAction
                id="audio-service-switch"
                checked={autoScrollAudioService}
                value={autoScrollAudioService}
                onChange={onAutoScrollAudioServiceHandler}
                disabled={isDisabledVoiceScroll}
                className={isDisabledVoiceScroll ? classes.disabledSwitch : ''}
              />
            )}
            data-intercom-target="Switch: Voice Scroll"
          />
        </Grid>
      </StudioToolTip>

      {
        isConnectingAudioService
        && (
          <StudioToolTip title="Measures the background noise">
            <Grid item>
              <Button
                disabled={isCalibrating}
                className={classes.button}
                onClick={calibrateHandler}
                data-intercom-target="Button: Calibrate"
              >
                <img src={WaveIcon} className={classes.icon} style={{ marginRight: 10 }} alt="" />
                Calibrate
              </Button>
            </Grid>
          </StudioToolTip>
        )
      }
      <CalibratingModal />
    </Grid>
  );
};

export default AudioServiceAction;
